import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { getFeatureFlagsThunk } from 'store/features/thunk';
import { isThereAnyToken } from 'utils/accessToken';

import { isAppLoadingSelector } from '../store/app/selectors';
import {
  isAuthenticatedSelector,
  isAfterLogoutSelector,
  isUnauthorizedSelector,
  isUserBlockedSelector,
  isUserDeletedSelector,
  isUserGuestOnlySelector,
} from '../store/auth/selectors';
import { getMeThunk } from '../store/user/thunks';

export function useAuthentication() {
  const dispatch = useDispatch();
  const [isSent, setIsSent] = useState(!isThereAnyToken());
  const isAuthenticated = useSelector(isAuthenticatedSelector);
  const isAppLoading = useSelector(isAppLoadingSelector);
  const isAfterLogout = useSelector(isAfterLogoutSelector);
  const isUnauthorized = useSelector(isUnauthorizedSelector);
  const isUserBlocked = useSelector(isUserBlockedSelector);
  const isUserDeleted = useSelector(isUserDeletedSelector);
  const isUserGuestOnly = useSelector(isUserGuestOnlySelector);

  useEffect(() => {
    if (isThereAnyToken()) {
      dispatch(getMeThunk())
        .then(() => {
          setIsSent(true);
          dispatch(getFeatureFlagsThunk());
        })
        .catch((error) => {
          console.error('Error during authentication flow:', error);
        });
    }
  }, [dispatch]);

  return {
    isSent,
    isAuthenticated,
    isAppLoading,
    isAfterLogout,
    isUnauthorized,
    isUserBlocked,
    isUserDeleted,
    isUserGuestOnly,
  };
}
